<template>
  <el-card>
    <h3>Change Password</h3>
    <el-col :span="12">
      <el-form
        ref="form"
        label-position="right"
        label-width="200px"
        :model="value"
        :rules="rules"
        @submit.prevent
      >
        <el-form-item
          :error="errors.password"
          prop="password"
          label="New password"
        >
          <el-input
            v-model="value.password"
            type="password"
            :disabled="loading"
          />
        </el-form-item>
        <el-form-item
          :error="errors.password_confirmation"
          prop="password_confirmation"
          label="Password confirmation"
        >
          <el-input
            v-model="value.password_confirmation"
            type="password"
            :disabled="loading"
          />
        </el-form-item>
        <el-form-item
          :error="errors.current_password"
          prop="current_password"
          label="Current password"
        >
          <el-input
            v-model="value.current_password"
            type="password"
            :disabled="loading"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            plain
            :disabled="loading"
            :icon="loading ? 'LoadingElementIcon' : ''"
            @click.prevent="onSubmit"
          >
            Save
          </el-button>
        </el-form-item>
      </el-form>
    </el-col>
  </el-card>
</template>

<script lang="ts">
import { defineComponent, ref, reactive, onMounted } from 'vue'
import { ProfileValidationErrorsKey } from '@/api/types'
import { IPasswordAttributes } from '@/api/users'
import { useUserStore } from '@/store/modules/user'
import useValidation from '@/hooks/useValidation'
import { ElMessage } from 'element-plus'

export default defineComponent({
  name: 'PasswordForm',
  setup(props, context) {
    const userStore = useUserStore()
    const loading = ref(false)
    const value = reactive({})
    const { provideValidation, setValidationErrors } = useValidation(
      ProfileValidationErrorsKey
    )
    const errors = provideValidation()
    const form = ref(null)
    const onSubmit = function () {
      // @ts-ignore: Object is possibly 'null'.
      form.value.validate(async (valid: boolean) => {
        if (valid) {
          loading.value = true
          try {
            const payload = value as IPasswordAttributes
            await userStore.ChangePassword(payload)
            ElMessage.success({
              message: 'Password has been changed',
              type: 'success'
            })
          } catch (err: any) {
            setValidationErrors(err, errors)
          } finally {
            loading.value = false
          }
        }
      })
    }

    const rule = {
      required: true,
      min: 12,
      message: 'Length should be greather than 11',
      trigger: 'change'
    }

    const rules = {
      password: rule,
      password_confirmation: rule,
      current_password: { ...rule, min: 8 }
    }

    return { loading, value, errors, onSubmit, rules, form }
  }
})
</script>
